interface TestCutInputsProps {
  cncDiameter: string;
  measuredDiameter: string;
  onCncChange: (value: string) => void;
  onMeasuredChange: (value: string) => void;
  error: number | null;
}

export function TestCutInputs({
  cncDiameter,
  measuredDiameter,
  onCncChange,
  onMeasuredChange,
  error
}: TestCutInputsProps) {
  const handleInputChange = (
    value: string,
    setter: (value: string) => void
  ) => {
    // Allow empty, negative sign, decimal point, and numbers
    if (value === '' || value === '-' || value === '.' || value === '-.') {
      setter(value);
      return;
    }
    // Validate numeric input (including negative and decimal)
    if (/^-?\d*\.?\d*$/.test(value)) {
      setter(value);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4">
        Test Cut Measurements
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label
            htmlFor="cnc-diameter"
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            CNC Programmed Diameter (X2)
          </label>
          <div className="relative">
            <input
              id="cnc-diameter"
              type="text"
              inputMode="decimal"
              value={cncDiameter}
              onChange={(e) => handleInputChange(e.target.value, onCncChange)}
              placeholder="0.000"
              className="
                w-full px-4 py-2 pr-12 font-mono text-lg rounded-lg
                border-2 border-gray-300 dark:border-gray-600
                bg-white dark:bg-gray-700
                text-gray-800 dark:text-gray-200
                placeholder-gray-400 dark:placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-industrial-500 focus:border-transparent
              "
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400">
              mm
            </span>
          </div>
        </div>

        <div>
          <label
            htmlFor="measured-diameter"
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Measured Diameter
          </label>
          <div className="relative">
            <input
              id="measured-diameter"
              type="text"
              inputMode="decimal"
              value={measuredDiameter}
              onChange={(e) => handleInputChange(e.target.value, onMeasuredChange)}
              placeholder="0.000"
              className="
                w-full px-4 py-2 pr-12 font-mono text-lg rounded-lg
                border-2 border-gray-300 dark:border-gray-600
                bg-white dark:bg-gray-700
                text-gray-800 dark:text-gray-200
                placeholder-gray-400 dark:placeholder-gray-500
                focus:outline-none focus:ring-2 focus:ring-industrial-500 focus:border-transparent
              "
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400">
              mm
            </span>
          </div>
        </div>
      </div>

      {error !== null && (
        <div className={`
          mt-4 p-3 rounded-lg
          ${error === 0
            ? 'bg-green-100 dark:bg-green-900/30 border border-green-300 dark:border-green-700'
            : 'bg-yellow-100 dark:bg-yellow-900/30 border border-yellow-300 dark:border-yellow-700'
          }
        `}>
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Error (Measured - Programmed):
            </span>
            <span className={`
              font-mono text-lg font-bold
              ${error === 0
                ? 'text-green-700 dark:text-green-400'
                : error > 0
                  ? 'text-red-600 dark:text-red-400'
                  : 'text-blue-600 dark:text-blue-400'
              }
            `}>
              {error > 0 ? '+' : ''}{error.toFixed(4)} mm
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
